export function describeGame(g, nameFor) {
  const name1 = nameFor(g.player1Id);
  const name2 = nameFor(g.player2Id);
  const hi = Math.max(g.player1Score, g.player2Score);
  const lo = Math.min(g.player1Score, g.player2Score);

  if (g.player1Score === g.player2Score) {
    return `${name1} and ${name2} tie ${hi} - ${lo}`;
  }
  const winner = g.player1Score > g.player2Score ? name1 : name2;
  const loser = g.player1Score > g.player2Score ? name2 : name1;
  return `${winner} beats ${loser} ${hi} - ${lo}`;
}
